import { Counter, Data, Filter, Pager, Query, Result } from '@/models/dynamiclist';
import { State } from '@/types';
import Vue from 'vue';
import { MutationTree } from 'vuex';
import { FilterQuery, PagingOptions } from '../models/dynamiclist';

export const mutations: MutationTree<State> = {
    setData: (state, data: Data) => {
        state.data = data;
    },
    setPager: (state, pager: Pager) => {
        Vue.set(state, 'pager', pager);
        Vue.set(state.query, 'pagingOptions', {
            disablePaging: pager.disablePaging,
            page: pager.page,
            pageSize: pager.pageSize
        } as PagingOptions);
    },
    setResults: (state, results: Result[]) => {
        state.results = results;
    },
    setCounter: (state, counter: Counter) => {
        state.counter = counter;
    },
    setFilters: (state, filters: Filter[]) => {
        state.filters = filters;
    },
    setQuery: (state, query: Query) => {
        state.query = query;
    },
    setFilterQuery: (state: State, cmd: { filterId: string, filterQuery: FilterQuery<any> }) => {
        Vue.set(state.query.filterQueries, cmd.filterId, cmd.filterQuery);
    },
    setFilterQueryValue: (state: State, cmd: { filterId: string, value: any }) => {
        Vue.set(state.query.filterQueries[cmd.filterId], 'value', cmd.value);
    },
    setError: (state, error: any) => {
        state.error = error;
    },
    setActive: (state, filterId: string) => {
        state.activeFilterId = filterId;
    },
    setPagingOptions: (state: State, pagingOptions: PagingOptions) => {
        Vue.set(state.query, 'pagingOptions', pagingOptions);
    },
    resetPagingOptions: (state: State) => {
        Vue.set(state.query, 'pagingOptions', {
            disablePaging: state.pager.disablePaging,
            pageSize: state.pager.pageSize,
            page: 0
        } as PagingOptions);
    }
};
